export default __webpack_public_path__ + "static/cliffGravesFar-63e416e8489173eefbce5cfd0cad99f8.svg";